module.exports = __webpack_public_path__ + "img/cpxq4.93de6088.png";